import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import type { FinanceForm } from 'app/typings/hotels/Finance/Finance';
import { apiMutation } from 'app/utils/request/api';

const saveHotelFinancePath = 'hotels/:hotelId/finance' as const;

export function useSaveHotelFinance(hotelId: string) {
  return useMutation({
    mutationFn: async (payload: FinanceForm) =>
      apiMutation(
        'PUT',
        {
          path: saveHotelFinancePath,
          params: { hotelId },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      message.success('Hotel successfully saved!');
    },
    onError: () => {
      message.error('Error posting services');
    },
  });
}
